<template>
  <div v-if="workPermissionList.length > 0" class="col-sm-12 list-content result-table">
      <vue3-datatable
          ref="resultTable"
          :rows="workPermissionList"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="editItem"
      >
          <template
              #id="row"
          >
              <span>{{ row.value.id }}</span>
          </template>
          <template
              #created="row"
          >
              <span>{{ toLocalTime(row.value.created) }}</span>
          </template>
          <template
              #handling_time="row"
          >
              <span>{{ toLocalTime(row.value.handling_time) }}</span>
          </template>
      </vue3-datatable>
  </div>
</template>

<script>
import {workPermissionHelper} from '../mixins/WorkPermissionMixin'
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'WorkPermissionList',
    components: {Vue3Datatable},
    mixins: [workPermissionHelper, timeUtils],
    props: {
        workPermissions: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    data: function () {
        return {
            sortBy: 'id',
            workPermissionList: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('work_permission.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'created', title: this.$t('work_permission.created'), sort: true, headerClass: 'routa-table-header'},
                {field: 'requested_by', title: this.$t('work_permission.requested_by'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('work_permission.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('work_permission.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract', title: this.$t('work_permission.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('work_permission.info'), sort: false, headerClass: 'routa-table-header'},
                {field: 'handled_by', title: this.$t('work_permission.handled_by'), sort: true, headerClass: 'routa-table-header'},
                {field: 'handling_time', title: this.$t('work_permission.handled_at'), sort: true, headerClass: 'routa-table-header'},
                {field: 'handlers_note', title: this.$t('work_permission.handlers_note'), sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        workPermissions() {
            this.workPermissionList = []
            let temp = []
            this.workPermissions.forEach(item =>
                temp.push({
                    ...item,
                    id: item.id,
                    created: item.created,
                    handling_time: item.handling_time,
                    contract: item.contract ? item.contract.name : '-',
                    requested_by: item.requested_by ? this.getName(item.requested_by) : '',
                    status: item.status ? this.getPermissionStatusString(item.status) : '',
                    type: item.type ? this.getTypeString(item.type) : '',
                    info: item.info,
                    handlers_note: item.handlers_note,
                    handled_by: item.handled_by ? this.getName(item.handled_by) : '',
                })
            )
            this.$nextTick(() => {
                this.workPermissionList = temp
            })
        }
    },
    mounted() {
        this.workPermissionList = this.workPermissions
    },
    methods: {
        editItem: function (workPermission) {
            let r = this.workPermissionList.find(item => item.id === workPermission.id)
            if (r) {
                this.$emit('rowClicked', r)
            }
        }
    }
}
</script>
